module.exports = __webpack_public_path__ + "static/media/imm_Domande.0456dc21.png";